import { User } from '../models/user';

export const fullname = (user: User) => (user ? `${user.firstName} ${user.lastName}` : '');

export const anonymizeEmail = (email: string) =>
  email
    .split('')
    .map((c, i) => (i > 2 && i <= email.length - 5 ? '*' : c))
    .join('');
